const PageRouteToPlaceHolderMap = {
	HOME_PAGE: { route: 'home', placeholder: 'home_page.home_bottom' },
    PRODUCT_PAGE: { route: 'shop.productdetails', placeholder: 'item_page.bottom' },
    SUBCATEGORY_PAGE: { route: 'shop.browse.department.subdepartment.category.subcategory', placeholder: 'category_page.bottom' },
    CATEGORY_PAGE: { route: 'shop.browse.department.subdepartment.category', placeholder: 'category_page.bottom' },
    SUBDEPARTMENT_PAGE: { route: 'shop.browse.department.subdepartment', placeholder: 'category_page.bottom' },
    DEPARTMENT_PAGE: { route: 'shop.browse.department', placeholder: 'category_page.department_top' },

    SEARCH_PAGE: { route: 'shop.search', placeholder: 'search_page.results_bottom' },
    // SEARCH_PAGE_NO_RESULT: { placeholder: 'search_page.noresults_bottom' },

    WATCHLIST_PAGE: { route: 'shop.watchlist', placeholder: 'generic_page.wishlist_bottom' },
    STORE_PAGE: { route: 'shop.locator.store', placeholder: 'home_page.storedetails_bottom' },

    ERROR_404_PAGE: { route: 'shop.404error', placeholder: 'home_page.error_bottom' },
	ERROR_500_PAGE: { route: 'shop.500error', placeholder: 'home_page.error_bottom' },

	MYACCOUNT_PAGE: { route: 'shop.myaccount', placeholder: 'home_page.myaccount_bottom' },

    PURCHASE_COMPLETE: { route: 'shop.checkout', placeholder: 'purchase_complete_page' },

    ADD_TO_CART: { placeholder: 'add_to_cart_page' },
    ADD_TO_WATCHLIST: { placeholder: 'item_page' },
    CART_PAGE: { placeholder: 'cart_page' }
};

module.exports = PageRouteToPlaceHolderMap;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/richer-relevance/page-to-placeholder-mapper.js
 **/